import { Controller } from "@hotwired/stimulus"

// Add exclusions drawer on the partner Configuration page. Keeps checked
// search results in a Selected zone that sits outside the auto-search results
// container, so a new search doesn't drop them, and enables the submit button
// once at least one item and one exclusion type are checked.
//
// Each result row is an element with data-excluded-locations-picker-key
// ("location_ids[]:12", "eins[]:123456789") wrapping its checkbox. Checking a
// result moves the row into the Selected list; unchecking a selected row
// removes it. Fresh results whose key is already selected are dropped.
export default class extends Controller {
  static targets = ["results", "selectedSection", "selectedList", "summary", "submit"]

  connect() {
    this.refresh()
  }

  // change-> on the form: a result, selected item, or exclusion type toggled.
  changed(event) {
    const checkbox = event.target
    const row = checkbox.closest("[data-excluded-locations-picker-key]")
    if (row) {
      if (checkbox.checked && this.hasResultsTarget && this.resultsTarget.contains(row)) {
        if (this._selectedKeys().has(row.dataset.excludedLocationsPickerKey)) {
          row.remove()
        } else {
          this.selectedListTarget.appendChild(row)
        }
      } else if (!checkbox.checked && this.selectedListTarget.contains(row)) {
        row.remove()
      }
    }
    this.refresh()
  }

  // The auto-search controller replaced the results; drop already-selected ones.
  resultsUpdated() {
    this.refresh()
  }

  refresh() {
    this._dedupeResults()
    const count = this.selectedListTarget.querySelectorAll("[data-excluded-locations-picker-key]").length
    const types = this.element.querySelectorAll('input[name="exclusion_types[]"]:checked').length

    this.selectedSectionTarget.hidden = count === 0
    if (this.hasSummaryTarget) {
      this.summaryTarget.textContent = count === 0 ? "No entities selected" : `${count} selected`
    }
    if (this.hasSubmitTarget) this.submitTarget.disabled = count === 0 || types === 0
  }

  _selectedKeys() {
    return new Set(
      Array.from(this.selectedListTarget.querySelectorAll("[data-excluded-locations-picker-key]"))
        .map(row => row.dataset.excludedLocationsPickerKey)
    )
  }

  _dedupeResults() {
    if (!this.hasResultsTarget) return
    const selected = this._selectedKeys()
    this.resultsTarget.querySelectorAll("[data-excluded-locations-picker-key]").forEach(row => {
      if (selected.has(row.dataset.excludedLocationsPickerKey)) row.remove()
    })
    this.resultsTarget.querySelectorAll("[data-excluded-locations-picker-group]").forEach(group => {
      group.hidden = !group.querySelector("[data-excluded-locations-picker-key]")
    })
  }
}
